import { render, staticRenderFns } from "./TabItemList.vue?vue&type=template&id=e23a9382&"
import script from "./TabItemList.vue?vue&type=script&lang=js&"
export * from "./TabItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports